import controller from './kform-component.controller';
import template from './kform-component.html';

const kformComponentDirective = /* @ngInject */ (
	/** @type {import('angular').translate.ITranslateService} */ $translate,
	/** @type {any} */ Notification,
) => ({
	replace:  true,
	restrict: 'E',
	scope:    {
		component:      '=',
		data:           '=',
		files:          '=?',
		form:           '=',
		formName:       '=',
		gridCol:        '=',
		gridRow:        '=',
		hideComponents: '=',
		options:        '=?',
		readOnly:       '=',
		submission:     '=',
	},
	require:  '^^?kform',
	template,
	link:     (
		/** @type {any} */ scope,
		/** @type {any} */ elements,
		/** @type {any} */ attributes,
		/** @type {any} */ kform,
	) => {
		/** @type {import('~/components/kform/kform.controller').default} */
		scope.kform = kform;
		scope.showAlerts = (/** @type {any} */ alerts) => {
			try {
				alerts.message = (JSON.parse(alerts.message)).data;
			}
			// eslint-disable-next-line no-empty
			catch {}

			Notification.error({
				title:   $translate.instant('error.title'),
				message: alerts,
			});
		};
		scope.getStyle = (/** @type {any} */ component) => {
			const newStyle = { ...component.style };
			if (component.hidden) {
				newStyle.display = 'none';
			}
			return newStyle;
		};
	},
	controller,
});

export default kformComponentDirective;
